<script lang="ts">
  "use strict";
  import Layout from "../app/layout.svelte";
  import Wapp from "../app/wapp.svelte";
  import { setupI18n } from "../services/i18n";

  setupI18n();
</script>

<Layout />
<Wapp  />
